import React, { PropsWithChildren } from 'react';
import { getTranslateByKey } from '@/main/services/utils';
import { IconButton, Menu } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage';
import * as S from './styles';
import { ThreeDotsPartClaimProvider, useThreeDotsPartClaimContext } from './context';

interface IThreeDotsPartSearchClaimProps {
  idScreen: string;
}
function ThreeDotsPartSearchClaimInternal({
  children
}: PropsWithChildren<IThreeDotsPartSearchClaimProps>) {
  const ID_MENU = 'id-menu-three-dots-quote';
  const {
    anchorEl,
    setAnchorEl
  } = useThreeDotsPartClaimContext();


  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  };
  function handleClose() {
    setAnchorEl(null);
  };


  const tooltipMessage = getTranslateByKey('information.clickToSeeTheActions');

  return (
    <S.Container>
      <RenderTooltipMessage tooltipMessage={tooltipMessage}>
        <IconButton
          aria-label="more"
          aria-haspopup="true"
          aria-controls={ID_MENU}
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      </RenderTooltipMessage>

      <Menu
        id={ID_MENU}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        keepMounted
        onClose={handleClose}
        elevation={2}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        style={{ zIndex: 1 }}
      >
        <div>
          {children}
        </div>
      </Menu>
    </S.Container>
  )
}

function ThreeDotsPartSearchClaim(props: PropsWithChildren<IThreeDotsPartSearchClaimProps>) {

  return (
    <ThreeDotsPartClaimProvider idScreen={props.idScreen}>
      <ThreeDotsPartSearchClaimInternal {...props} />
    </ThreeDotsPartClaimProvider>
  )
}

export default ThreeDotsPartSearchClaim